import SolarEstimate from '~/components/widgets/SolarEstimate/SolarEstimate.ce.vue';
import { defineCustomVueElement } from '~/build/utils/createCustomElement';

export const SolarEstimateElement = defineCustomVueElement({
    component: SolarEstimate,
    name: 'solar-estimate',
});

export default SolarEstimateElement;
